import React from "react";
import { Button } from "../../PSY/Button";
import { useNavigate } from "react-router-dom";
import { CollateralLexicon } from "../../../lexicon";
import { COIN, GT } from "../../../strings";
import { getContractAddressByCollateralKey } from "@liquity/lib-ethers";
import { useLiquity } from "src/hooks/LiquityContext";
import { Decimal } from "@liquity/lib-base"

type Props = {
  collateralName: string;
  deposit: string;
  totalDeposit: string;
  collateralGain?: string;
  psyReward?: Decimal;
  lexicon: CollateralLexicon;
  collateralKey: string;
};

export const MySpPosition: React.FC<Props> = ({
  collateralName,
  deposit,
  totalDeposit,
  collateralGain,
  psyReward,
  lexicon,
  collateralKey
}) => {
  const navigate = useNavigate();
  const { liquity: { connection } } = useLiquity();
  const { spAddress } = getContractAddressByCollateralKey(connection, collateralKey)

  return (
    <div className="bg-component flex flex-col md:flex-row justify-between py-5">
      <div className="bg-component flex flex-col w-full">
        <div className="flex flex-row justify-between">
          <div className="flex flex-row">
            <img src={lexicon.iconUrl} alt={lexicon.term} className="w-8 h-8" />
            <div className="flex flex-col ml-3">
              <div className="text-style-item">{collateralName}</div>
              <div className="text-style-label text-blurWhite">({lexicon.term})</div>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-2 mt-4 md:flex-row md:w-3/5 justify-between">
          <div className="flex flex-row justify-between md:flex-col">
            <div className="text-style-label">Total Deposit</div>
            <div className="text-style-item">
              {totalDeposit}
              <span className="ml-0.5">{COIN}</span>
            </div>
          </div>
          <div className="flex flex-row justify-between md:flex-col">
            <div className="text-style-label">Your Deposit</div>
            <div className="text-style-item">
              {deposit}
              <span className="ml-0.5">{COIN}</span>
            </div>
          </div>
          <div className="flex flex-row justify-between md:flex-col">
            <div className="text-style-label">APR</div>
            <div className="text-style-item">N/A</div>
          </div>
        </div>
        {/* {(collateralGain || psyReward) && ( */}
        <div className="flex flex-row justify-between mt-2 md:flex-col">
          <div className="text-style-label">Rewards</div>
          <div className="flex flex-row text-style-item">
            {collateralGain}
            <span className="ml-0.5">{lexicon.term}</span>
            {psyReward && psyReward.gt(0) && (
              <div className="ml-1.5">
                + {psyReward.prettify(3)}
                <span className="ml-0.5">{GT}</span>
              </div>
            )}
          </div>
        </div>
        {/* )} */}
      </div>

      <div className="mt-3 md:mt-0">
        <Button
          onSubmit={() => {
            navigate(`stability-pools/${spAddress}`);
          }}
          className="w-full md:w-32"
        >
          Manage
        </Button>
      </div>
    </div>
  );
};
